import { MaterialGroup } from '@cutr/constants/cutlist';

import { useActiveGroupGrainDirection } from '@/api/materialsGroup';
import { getSourceConfig, useCurrentFeatures } from '@/theme';

export const useProcessingSettingsConfig = ({
  group,
}: {
  group: MaterialGroup;
}) => {
  const { nestingConfig } = getSourceConfig();
  const { isSheetStackingEnabled } = nestingConfig;
  const {
    hasEdgeProfiling,
    showSheetEdgeTrimUi,
    hasPaintingOption,
    visibleGroupTypesOnSingleCore,
    hasCreateLabels,
    grainDirectionLevel,
  } = useCurrentFeatures();
  const hasGrainDirection = useActiveGroupGrainDirection();

  const isPartSawing = group.type === 'panels-and-strips';
  const groupHasMaterialAndType = group.type && group.core1;

  const showEdgeProfiling =
    groupHasMaterialAndType && isPartSawing && hasEdgeProfiling;
  const showEdgeTrimComponent = groupHasMaterialAndType && showSheetEdgeTrimUi;
  const showSheetStackingComponent =
    groupHasMaterialAndType && isSheetStackingEnabled;
  const showPainting = groupHasMaterialAndType && hasPaintingOption;
  const showCreateLabels =
    groupHasMaterialAndType && hasCreateLabels === 'group';
  const showGrainDirection =
    groupHasMaterialAndType &&
    grainDirectionLevel === 'group' &&
    hasGrainDirection;

  const shouldShowGroupTypeSelect = () => {
    if (
      group.materialSandwichType &&
      group.materialSandwichType !== 'single-core'
    )
      return true;

    if (visibleGroupTypesOnSingleCore.length > 1) return true;

    return false;
  };

  const showGroupTypeSelect = shouldShowGroupTypeSelect();

  const hasProcessingSettings =
    showEdgeProfiling ||
    showEdgeTrimComponent ||
    showPainting ||
    showGroupTypeSelect ||
    showGrainDirection ||
    showSheetStackingComponent;

  return {
    showEdgeProfiling,
    showEdgeTrimComponent,
    showPainting,
    showGroupTypeSelect,
    showCreateLabels,
    hasProcessingSettings,
    showGrainDirection,
    showSheetStackingComponent,
  };
};
